import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import CallbackForm from "@/components/CallbackForm";
import { PhoneCall } from "lucide-react";

/**
 * Reusable callback dialog used across hero, pricing, payment screens.
 * Accepts either a `trigger` ReactNode or a built-in button with label.
 */
export default function CallbackDialog({
  trigger,
  label = "Speak To Our Team",
  plan = "",
  size = "default",
  variant = "default",
  className = "",
  testId = "callback-dialog",
  buttonTestId = "callback-dialog-trigger",
}) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <Button
            size={size}
            variant={variant}
            className={className}
            data-testid={buttonTestId}
          >
            <PhoneCall size={16} className="mr-2" />
            {label}
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="sm:max-w-lg" data-testid={testId}>
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-navy">
            Speak To Our Team
          </DialogTitle>
          <DialogDescription>
            Share your details and our team will call you back within 24 hours
            {plan ? (
              <>
                {" "}to discuss the{" "}
                <span className="font-medium text-navy">{plan}</span>.
              </>
            ) : (
              <>.</>
            )}
          </DialogDescription>
        </DialogHeader>
        <CallbackForm
          plan={plan}
          onSuccess={() => setOpen(false)}
          testPrefix={`${testId}-form`}
        />
      </DialogContent>
    </Dialog>
  );
}
